import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";
import BASE_URL from "../../BASEURL";
import {
  FaEye,
  FaEyeSlash,
  FaUser,
  FaEnvelope,
  FaArrowRight,
} from "react-icons/fa";

export default function Register() {
  const navigate = useNavigate();

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    // password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const cleaned = value.replace(/\D/g, "").slice(0, 10);
      setForm({ ...form, phone: cleaned });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

const handleRegister = async (e) => {
  e.preventDefault();

  const name = form.name.trim();
  const email = form.email.trim();
  const phone = form.confirmPassword.trim(); 

  if (!isValidPhone(phone)) {
    return toast.error("⚠️ Invalid phone number");
  }

  try {
    const res = await fetch(`${BASE_URL}/api/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        phone,
        password: phone, 
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      return toast.error(data.message || "Registration failed");
    }

    toast.success("🎉 Account created successfully!");

    setTimeout(() => {
      navigate("/login");
    }, 800);
  } catch (error) {
    console.error(error);
    toast.error("❌ Server error");
  }
};

  return (
    <section className="min-h-screen flex items-center justify-center bg-[#FCFBFA] py-16 px-6 relative overflow-hidden">

      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100/40 rounded-full -mr-48 -mt-48 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gray-100 rounded-full -ml-48 -mb-48 blur-3xl"></div>

      <div className="bg-white rounded-[3rem] shadow-[0_20px_70px_rgba(0,0,0,0.03)] border border-gray-100 w-full max-w-xl overflow-hidden flex flex-col md:flex-row relative z-10">

        <div className="hidden lg:flex w-2/5 bg-black p-12 text-white flex-col justify-between">
          <div>
            <h2 className="text-3xl font-bold mt-10 leading-tight">
              Begin Your <br />
              <span className="text-orange-500 italic">Spiritual</span> Journey.
            </h2>
          </div>
          <p className="text-gray-400 text-xs uppercase font-bold">
            Vastukkalp © 2026
          </p>
        </div>

        <div className="flex-1 p-8 md:p-12">

          <div className="mb-10">
            <h1 className="text-3xl font-bold text-black">
              Create <span className="text-orange-600 italic">Account</span>
            </h1>
            <p className="text-gray-400 text-sm">
              Join the community of Vastu experts.
            </p>
          </div>

          <form className="space-y-6" onSubmit={handleRegister}>

            <div>
              <label className="text-xs text-gray-400 flex items-center gap-2">
                <FaUser size={10} /> Full Name
              </label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="John Doe"
                className="w-full mt-2 px-4 py-3 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>

            <div>
              <label className="text-xs text-gray-400 flex items-center gap-2">
                <FaEnvelope size={10} /> Email
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="example@gmail.com"
                className="w-full mt-2 px-4 py-3 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>


            <div className="space-y-4">

          


              <div className="relative">
                    <label className="text-xs text-gray-400 flex items-center gap-2">
                📞 Phone Number
              </label>
                <input
  type="tel"
  name="confirmPassword"
  value={form.confirmPassword}
  onChange={(e) => {
    const cleaned = e.target.value.replace(/\D/g, "").slice(0, 10);
    setForm({ ...form, confirmPassword: cleaned });
  }}
  placeholder="Phone Number"
  maxLength={10}
  className="w-full px-4 py-3 bg-gray-50 rounded-xl outline-none focus:ring-2 focus:ring-orange-500"
/>
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-3 text-gray-400"
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

            </div>

            <button
              type="submit"
              className="w-full bg-black text-white py-4 rounded-xl flex justify-center items-center gap-2 hover:bg-orange-600 transition"
            >
              Sign Up <FaArrowRight />
            </button>

          </form>

          <p className="text-center mt-6 text-sm text-gray-400">
            Already have an account?{" "}
            <Link to="/login" className="text-black font-bold">
              Login
            </Link>
          </p>

        </div>
      </div>
    </section>
  );
}